<template>
  <div class="photo">
    <div class="b topLeft"></div>
    <div class="b topRight"></div>
    <div class="b bottomLeft"></div>
    <div class="b bottomRight"></div>
    <div class="savebutton">
      <el-button
        type="primary"
        icon="el-icon-camera"
        @click="savePerspective"
        v-if="!getPerspective"
        >保存视角</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "photoGraphic",
  props: ["modelPreview", "flightData", "getPerspective"],
  model: {
    prop: "flightData",
    event: "newFlightData",
  },
  data() {
    return {
      cameraView: {
        alt: null,
        heading: null,
        lat: null,
        lng: null,
        pitch: null,
      },
      sonFlightData: this.flightData,
    };
  },
  methods: {
    // 保存视角
    mapImg() {
      this.$GLOBAL.map.expImage({
        download: false,
        width: 200,
        callback: (image) => {
          let {
            alt,
            heading,
            lat,
            lng,
            pitch,
          } = this.$GLOBAL.map.getCameraView();
          console.log(alt, heading, lat, lng, pitch);
          this.$notify({
            title: "成功截取视角",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
        },
      });
    },
    savePerspective() {
      let { alt, heading, lat, lng, pitch } = this.$GLOBAL.map.getCameraView();
      this.cameraView = {
        alt,
        heading,
        lat,
        lng,
        pitch,
      };
      this.$notify({
        title: "成功截取视角",
        message: "",
        type: "success",
        duration: 960,
        offset: 320,
      });
      this.$parent.ifPhotoGraphic = false;
      this.modelPreview(true);
      this.sonFlightData.push(this.cameraView);
    },
  },
  mounted() {
    // this.sonFlightData = [];
  },
};
</script>
<style lang="scss" scoped>
.b {
  border: 5px solid white;
  height: 50px;
  width: 50px;
  position: fixed;
}
.topLeft {
  border-right: transparent;
  border-bottom: transparent;
  left: 272px;
  top: 74px;
}
.topRight {
  border-left: transparent;
  border-bottom: transparent;
  right: 20px;
  top: 74px;
}
.bottomLeft {
  border-right: transparent;
  border-top: transparent;
  left: 272px;
  bottom: 20px;
}
.bottomRight {
  border-left: transparent;
  border-top: transparent;
  right: 20px;
  bottom: 20px;
}
.savebutton {
  position: fixed;
  right: 100px;
  top: 100px;
}
.el-button--primary {
  @include lheight(30);
  @include font_color("t_color_op1");
  @include background_color("t_color1_op2");
  @include border_color("t_color1_op2");
  padding: 0px 10px;
  font-size: 12px;
  margin: 12px 0 0 8px;
  span {
    @include lheight(30);
    display: block;
    text-align: center;
  }
  &:hover {
    @include background_color("t_color1_op1");
    @include border_color("t_color1_op1");
  }
}
</style>
